import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { NotificationsPage } from '@/features/notifications/components';

function NotificationsRoute(): ReactNode {
  return (
    <AuthGuard>
      <NotificationsPage />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/notifications')({
  component: NotificationsRoute,
});
